import React, { useEffect, useState, useRef } from 'react';
import { Checkbox, Dropdown } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { MoreOutlined } from '@ant-design/icons';
import teacherIcon from "../../Assets/userManagementV3/teacherIcon.svg";
import operationIcon from "../../Assets/userManagementV3/operationIcon.svg";
import gridIcon from "../../Assets/userManagementV3/gridIcon.svg";
import listIcon from "../../Assets/userManagementV3/listIcon.svg";
import filterIcon from "../../Assets/userManagementV3/filterIcon.svg";
import PageHeader from 'components/pageHeader';
import PageDataLoader from 'components/pageDataLoader';
import { InputSearch } from 'components/customInputs';
import { Button } from 'components/Button';
import UserDeleteModal from '../userManagementV2/modals/userDelete';
import PermanentDeleteModal from '../userManagementV2/modals/parmanentDeleteModal';
import { getUsers, setSpecificUserId, setUserDetails, updateUserToTranferData } from 'actions/userManagementV2';
import { getStaffListV3, searchStaffV3, updateStaffStatusV3 } from 'actions/userManagementV3';
import { setOthersSelectedTab } from 'actions/profileNew';
import { IMG_URL } from '../../env.json';
import './userTableV2.css';
import AccessManagement from './localComponent/accessManagement';
import UserActionConfirmModal from './localComponent/userActionConfirmModal';
import UserAvatar from 'components/userAvatar';

const UserTableV2 = ({ userType, getUsers, usersList, userObj, setSpecificUserId, updateUserToTranferData, setUserDetails, setOthersSelectedTab, user, selectedStandard,
    selectedCourse, resourceData, storeWithoutData, userIds, staffList, getStaffListV3, searchStaffV3, updateStaffStatusV3
}) => {
    const history = useHistory();
    const location = useLocation();
    const fromUserManagement = true;

    const [search, setSearch] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [pageLoader, togglePageLoader] = useState(false);
    const [filter, setFilter] = useState({ page: 1, limit: 25 });
    const [userDeleteModalBool, setUserDeleteModalOpen] = useState(false);
    const [permanentDeleteModal, setPermanentDeletModal] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [viewMode, setViewMode] = useState('list');
    const [hoveredCardId, setHoveredCardId] = useState(null);
    const [sortOption, setSortOption] = useState('Newest');
    const [roleFilter, setRoleFilter] = useState('All');
    const [statusFilter, setStatusFilter] = useState('Active');
    const [actionRecord, setActionRecord] = useState(null);
    const [showAccessManagement, setShowAccessManagement] = useState(false);
    const filterRef = useRef(null);

    const defaultUser = userObj?.userRole === 'Students' ? 'Student' : 'Staff';
    const displayList = defaultUser === 'Staff' ? staffList : usersList;

    const params = {
        userType: defaultUser,
        status: ['Approved'],
        limit: 25,
        search,
        page: filter?.page,
        courseIds:
            location?.state?.key === 'fromStandardClick'
                ? [resourceData?.id]
                : defaultUser === 'Staff'
                    ? undefined
                    : resourceData === -1 || userIds
                        ? undefined
                        : [resourceData?.id],
        standardIds:
            location?.state?.key === 'fromStandardClick'
                ? [selectedStandard?.standard_id]
                : defaultUser === 'Staff' || selectedCourse !== 'Live Courses'
                    ? undefined
                    : [selectedStandard?.standard_id],
        userIds: location?.state?.key === 'fromStandardClick' ? undefined : userIds || undefined
    };

    useEffect(() => {
        if (showAccessManagement) return;
        togglePageLoader(true);
        if (defaultUser === 'Staff') {
            if (search && search.trim() !== '') {
                const searchParams = { search: search.trim() };
                searchStaffV3(searchParams, () => togglePageLoader(false));
            } else {
                const staffParams = {
                    status: statusFilter,
                    page: filter?.page,
                    limit: filter?.limit || 25,
                };
                getStaffListV3(staffParams, () => togglePageLoader(false));
            }
        } else {
            getUsers(params, () => togglePageLoader(false));
        }
    }, [search, filter, defaultUser, showAccessManagement]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                filterOpen &&
                filterRef.current &&
                !filterRef.current.contains(event.target)
            ) {
                setFilterOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [filterOpen]);

    const handleSearch = (value) => {
        setSearch(value);
        setFilter((prev) => ({ ...prev, page: 1, }));
    };

    const handleDirectStatusUpdate = (userId, status) => {
        togglePageLoader(true);
        updateStaffStatusV3(userId, status, () => {
            const staffParams = {
                status: statusFilter,
                page: filter?.page,
                limit: filter?.limit || 25,
            };
            getStaffListV3(staffParams, () => {
                togglePageLoader(false);
                setActionRecord(null);
            });
        });
    };

    const handleApplyFilter = () => {
        setFilterOpen(false);
        // If you want to send these values to API later,
        // add sortOption and roleFilter to params.
    };

    const handleResetFilter = () => {
        setSortOption('Newest');
        setRoleFilter('All');
        setStatusFilter('Active');
    };

    const handleGridView = () => {
        setViewMode((prev) => (prev === 'list' ? 'grid' : 'list'));
    };

    const handleRowClick = (record) => {
        setSpecificUserId(record?.id);
        setUserDetails(record);
        setOthersSelectedTab('Basic Profile');

        const basePath = location.pathname.startsWith('/user-management-v2') ? '/user-management-v2' : '/user-management';
        history.push({
            pathname: `${basePath}/profile`,
            state: { key: fromUserManagement }
        });
    };

    const toggleUserSelection = (id, checked) => {
        setSelectedRowKeys((prev) => checked ? [...prev, id] : prev.filter((item) => item !== id));
    };

    const toggleAllUsers = (checked) => {
        setSelectedRowKeys(checked ? (displayList?.items || []).map((item) => item.id) : []);
    };

    const renderUserRow = (record) => {
        const isSelected = selectedRowKeys.includes(record.id);
        const userRole = record?.role || record?.userRole || 'Teacher';
        const isOperations = userRole.toLowerCase().includes('operation');

        return (
            <div
                key={record.id}
                className="staff-card"
            >

                {/* ================= USER ROW ================= */}
                <div
                    className={`staff-data-row ${isSelected ? 'selected-row' : ''}`}
                    onClick={() => handleRowClick(record)}
                >

                    {/* CHECKBOX */}
                    <div className="staff-cell staff-checkbox-cell"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Checkbox
                            checked={isSelected}
                            onChange={(e) => toggleUserSelection(record.id, e.target.checked)}
                        />
                    </div>

                    {/* NAME */}
                    <div className="staff-cell staff-name-cell">
                        <div className="user-avatar" style={{ border: 'none', background: 'transparent' }}>
                            <UserAvatar
                                name={record?.name || 'N/A'}
                                img={record?.image ? `${IMG_URL}/${record.image}` : null}
                                size={42}
                            />
                        </div>

                        <div className="user-info">

                            <div className="user-name-wrapper">
                                <span className="user-name"> {record?.name || 'N/A'} </span>
                                <span className={`status-dot ${record?.status === 'Inactive' ? 'inactive' : 'active'}`} />
                            </div>

                            {record?.email && (
                                <span className="user-email"> {record.email} </span>
                            )}
                        </div>
                    </div>

                    {/* MOBILE */}
                    <div className="staff-cell staff-mobile-cell">
                        {record?.phone || record?.mobileNo || 'N/A'}
                    </div>

                    {/* ROLE */}
                    <div className="staff-cell staff-role-cell">
                        <div className={`role-icon-wrapper ${isOperations ? 'operations-bg' : 'teacher-bg'}`}>
                            <img
                                src={isOperations ? operationIcon : teacherIcon}
                                alt={userRole}
                            />
                        </div>

                        <span className="role-text"> {userRole} </span>
                    </div>

                    {/* { ACCESS } */}
                    <div className="staff-cell staff-access-cell">
                        {record?.access || record?.privilage?.split?.(',')?.[0] || 'Fee manager'}
                    </div>

                    {/* JOINED DATE */}
                    <div className="staff-cell staff-joined-cell">
                        {record?.createdAt ? moment(record.createdAt).format('DD/MM/YYYY') : ''}
                    </div>

                    {/* ACTIONS */}
                    <div
                        className="staff-cell staff-actions-cell"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Dropdown
                            placement="bottomRight"
                            // trigger={['hover']} // if need dropdown on hover
                            trigger={['click']}
                            overlayClassName="staff-actions-dropdown"
                            menu={{
                                items: [
                                    record?.status === 'Suspended' ? {
                                        key: 'activate',
                                        label: 'Activate',
                                        onClick: () => handleDirectStatusUpdate(record.id, 'Active')
                                    } : {
                                        key: 'suspend',
                                        label: 'Suspend',
                                        onClick: () => { setActionRecord(record); setUserDeleteModalOpen(true); }
                                    },
                                    {
                                        key: 'delete',
                                        label: 'Delete',
                                        danger: true,
                                        onClick: () => { setActionRecord(record); setPermanentDeletModal(true); }
                                    }
                                ]
                            }}
                        >
                            <Button
                                type="transparent"
                                style={{ padding: 0, height: 28, width: 28 }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <MoreOutlined className="more-icon" />
                            </Button>
                        </Dropdown>
                    </div>
                </div>
            </div>
        );
    };
    const renderGridCard = (record) => {
        const isSelected = selectedRowKeys.includes(record.id);
        const isHovered = hoveredCardId === record.id;
        const userRole = record?.role || record?.userRole || 'Teacher';
        const access = record?.access || record?.privilage?.split?.(',')?.[0] || 'Fee manager';
        const isOperations = userRole.toLowerCase().includes('operation');
        const mobile = record?.phone || record?.mobileNo || 'N/A';
        const joinedOn = record?.createdAt ? moment(record.createdAt).format('DD/MM/YYYY') : 'N/A';

        return (
            <div
                key={record.id}
                className={` staff-grid-item ${isSelected ? 'is-selected' : ''} ${isHovered ? 'is-hovered' : ''} `}
                onClick={() => setHoveredCardId(prev => prev === record.id ? null : record.id)}
            >

                <div className="staff-grid-card">
                    <div className="staff-grid-normal-top">
                        <div className="staff-grid-normal-user-info">
                            {/* NAME */}
                            <div className="staff-grid-name-row">
                                <span className="staff-grid-name"> {record?.name || 'N/A'} </span>
                                <span className={` status-dot ${record?.status === 'Inactive' ? 'inactive' : 'active'}`} />
                            </div>
                            {/* MOBILE */}
                            <span className="staff-grid-mobile"> {mobile} </span>
                        </div>

                        {/* PROFILE IMAGE */}
                        <div className="staff-grid-avatar" style={{ border: 'none', background: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <UserAvatar
                                name={record?.name || 'N/A'}
                                img={record?.image ? `${IMG_URL}/${record.image}` : null}
                                size={50}
                            />
                        </div>
                    </div>

                    <div className="staff-grid-role-access">
                        <div className="staff-grid-role">
                            <div className={` role-icon-wrapper ${isOperations ? 'operations-bg' : 'teacher-bg'}`}>
                                <img src={isOperations ? operationIcon : teacherIcon} alt={userRole} />
                            </div>
                            <span className="staff-grid-role-text"> {userRole} </span>

                            {/* <span className="staff-grid-access-bracket"> ( </span> */}
                            <span className="staff-grid-access-text"> ({access}) </span>
                            {/* <span className="staff-grid-access-bracket"> ( </span> */}

                        </div>
                    </div>
                </div>

                {/*EXPANDED HOVER CARD */}
                {isHovered && (
                    <div
                        className={` staff-grid-expanded-card ${isSelected ? 'expanded-selected' : ''} `}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/*TOP SECTION */}
                        <div className="staff-grid-expanded-top">

                            <div
                                className="staff-grid-expanded-checkbox"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Checkbox
                                    checked={isSelected}
                                    onChange={(e) => { toggleUserSelection(record.id, e.target.checked); }}
                                />
                            </div>

                            {/* USER DETAILS */}
                            <div className="staff-grid-expanded-user-info">

                                {/* NAME */}
                                <div className="staff-grid-name-row">
                                    <span className="staff-grid-name"> {record?.name || 'N/A'} </span>
                                    <span className={` status-dot ${record?.status === 'Inactive' ? 'inactive' : 'active'}`} />
                                </div>
                                <span className="staff-grid-mobile"> {mobile} </span>
                                <span className="staff-grid-joined"> Joined on {joinedOn} </span>

                            </div>

                            {/* PROFILE */}
                            <div className="staff-grid-profile">

                                <div className="staff-grid-avatar" style={{ border: 'none', background: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <UserAvatar
                                        name={record?.name || 'N/A'}
                                        img={record?.image ? `${IMG_URL}/${record.image}` : null}
                                        size={60}
                                    />
                                </div>
                                <button
                                    type="button"
                                    className="staff-grid-view-profile"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRowClick(record);
                                    }}
                                >
                                    VIEW PROFILE
                                </button>
                            </div>
                        </div>

                        {/*  ROLE / ACCESS */}
                        <div className="staff-grid-expanded-details">
                            <div className="staff-grid-detail-row">
                                <div className="detail-label"> Role: </div>
                                <div className="detail-value"> {userRole} </div>
                            </div>

                            <div className="staff-grid-detail-row">
                                <div className="detail-label"> Access: </div>
                                <div className="detail-value"> {access} </div>
                            </div>
                        </div>


                        {/* ACTIONS */}
                        <div className="staff-grid-expanded-actions">

                            {/* <button
                                type="button"
                                className="grid-manage-btn"
                                onClick={(e) => { e.stopPropagation(); handleRowClick(record); }}
                            >
                                MANAGE DATA
                            </button> */}

                            {record?.status === 'Suspended' ? (
                                <button
                                    type="button"
                                    className="grid-suspend-btn"
                                    style={{ color: '#008a67' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDirectStatusUpdate(record.id, 'Active');
                                    }}
                                >
                                    ACTIVATE
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="grid-suspend-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setActionRecord(record);
                                        setUserDeleteModalOpen(true);
                                    }}
                                >
                                    SUSPEND
                                </button>
                            )}

                            <button
                                type="button"
                                className="grid-delete-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setActionRecord(record);
                                    setPermanentDeletModal(true);
                                }}
                            >
                                DELETE
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const pageHeaderActions = [
        selectedRowKeys.length > 0 ? (
            <div
                key="bulk-actions"
                className="bulk-actions"
            >
                <button
                    type="archive"
                    className="bulk-suspend-btn"
                    onClick={() => setUserDeleteModalOpen(true)}
                >
                    SUSPEND
                </button>

                <button
                    type="delete"
                    className="bulk-delete-btn"
                    onClick={() => setPermanentDeletModal(true)}
                >
                    DELETE
                </button>
            </div>
        ) : (
            <div
                key="staff-table-tools"
                className="staff-table-tools"
            >
                {/* SEARCH */}
                <div className="staff-search-wrapper" ref={filterRef}>

                    <InputSearch
                        value={search}
                        allowClear={false}
                        placeholder="Search by name/mobile number"
                        onEnter={(e) => { handleSearch }}
                        onChange={(e) => {
                            const value = typeof e === 'string' ? e : e?.target?.value || '';
                            setSearch(value);
                        }}
                        style={{ borderRadius: '32px', width: 420, height: "40px", }}
                    />
                    {/* CUSTOM CLEAR BUTTON */}
                    {search && (
                        <button
                            type="button"
                            className="staff-search-clear"
                            onClick={(e) => { handleSearch('') }}
                        >
                            ×
                        </button>
                    )}

                    {/* FILTER ICON */}
                    <button
                        type="button"
                        className={`staff-filter-button ${filterOpen ? 'active' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            setFilterOpen((prev) => !prev);
                        }}
                    >
                        <img src={filterIcon} alt="filter" style={{ width: "28px", height: "28px" }} />
                    </button>

                    {/* FILTER DROPDOWN */}
                    {filterOpen && (
                        <FilterDropdown
                            sortOption={sortOption}
                            roleFilter={roleFilter}
                            statusFilter={statusFilter}
                            setSortOption={setSortOption}
                            setRoleFilter={setRoleFilter}
                            setStatusFilter={setStatusFilter}
                            onReset={handleResetFilter}
                            onApply={handleApplyFilter}
                        />
                    )}
                </div>

                {/* LIST / GRID VIEW TOGGLE */}
                <button
                    type="button"
                    className={`staff-grid-button ${viewMode === 'grid' ? 'active' : ''
                        }`}
                    onClick={handleGridView}
                >
                    <img
                        src={viewMode === 'list' ? gridIcon : listIcon}
                        alt={viewMode === 'list' ? 'grid' : 'list'}
                        style={{
                            width: "20px",
                            height: "20px",
                        }}
                    />
                </button>
                <button
                    type="button"
                    className="manage-access-btn"
                    onClick={() => setShowAccessManagement(true)}
                >
                    MANAGE ACCESS
                </button>
            </div>
        )
    ];

    if (showAccessManagement) {
        return (
            <AccessManagement
                onBack={() => setShowAccessManagement(false)}
            />
        );
    }

    return (
        <div className="user-table-v2-wrapper">
            <PageHeader
                title={
                    selectedRowKeys.length > 0
                        ? `${selectedRowKeys.length} selected`
                        : userObj?.userRole === 'Students'
                            ? `${selectedStandard?.std || selectedCourse} (${displayList?.meta?.totalItems || 0})`
                            : 'Staff'
                }
                actions={pageHeaderActions}
                onBackPress={() => history.goBack()}
                summary={
                    <div className="staff-filter-summary">
                        <span>Sort: <span className='staff-filter-value'>{sortOption}</span></span>
                        <span className="staff-filter-summary-divider"> | </span>
                        <span>Role: <span className='staff-filter-value'>{roleFilter}</span></span>
                        <span className="staff-filter-summary-divider"> | </span>
                        <span>Status: <span className='staff-filter-value'>{statusFilter}</span></span>
                    </div>
                }
            />

            {viewMode === 'list' ? (
                <div className="table-container">

                    <div className="staff-table">
                        {/* TABLE HEADER */}
                        <div className="staff-table-header">
                            <div className="staff-header-cell staff-checkbox-cell">
                                <Checkbox
                                    checked={
                                        displayList?.items?.length > 0 &&
                                        selectedRowKeys.length ===
                                        displayList.items.length
                                    }
                                    indeterminate={
                                        selectedRowKeys.length > 0 &&
                                        selectedRowKeys.length <
                                        (displayList?.items?.length || 0)
                                    }
                                    onChange={(e) => toggleAllUsers(e.target.checked)}
                                />
                            </div>

                            <div className="staff-header-cell"> NAME </div>
                            <div className="staff-header-cell"> MOBILE NUMBER </div>
                            <div className="staff-header-cell"> ROLE </div>
                            <div className="staff-header-cell"> ACCESS </div>
                            <div className="staff-header-cell"> JOINED ON </div>
                            <div className="staff-header-cell"> ACTIONS </div>

                        </div>

                        {/* TABLE ROWS */}
                        <div className="staff-table-body">
                            {(displayList?.items || []).map((record) => renderUserRow(record))}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="staff-grid-wrapper">

                    <div className="staff-grid-selection-bar">

                        <Checkbox
                            checked={
                                displayList?.items?.length > 0 &&
                                selectedRowKeys.length ===
                                displayList.items.length
                            }
                            indeterminate={
                                selectedRowKeys.length > 0 &&
                                selectedRowKeys.length <
                                (displayList?.items?.length || 0)
                            }
                            onChange={(e) =>
                                toggleAllUsers(e.target.checked)
                            }
                        />

                        <span className="staff-grid-select-label"> Select all {selectedRowKeys.length > 0 && ` (${selectedRowKeys.length} selected)`} </span>

                    </div>

                    <div className="staff-grid-container">

                        {(displayList?.items || []).map((record) =>
                            renderGridCard(record)
                        )}
                    </div>
                </div>
            )}

            <PageDataLoader visible={pageLoader} />

            {userDeleteModalBool && (
                <UserActionConfirmModal
                    open={userDeleteModalBool}
                    onCancel={() => setUserDeleteModalOpen(false)}
                    onConfirm={() => {
                        if (actionRecord) {
                            handleDirectStatusUpdate(actionRecord.id, 'Suspended');
                            setUserDeleteModalOpen(false);
                        }
                    }}
                    action="suspend"
                    isBulk={selectedRowKeys.length > 1}
                />
            )}

            {permanentDeleteModal && (
                <UserActionConfirmModal
                    open={permanentDeleteModal}
                    onCancel={() => setPermanentDeletModal(false)}
                    onConfirm={() => {
                        if (actionRecord) {
                            handleDirectStatusUpdate(actionRecord.id, 'Deleted');
                            setPermanentDeletModal(false);
                        }
                    }}
                    action="delete"
                    isBulk={selectedRowKeys.length > 1}
                />
            )}
        </div>
    );
};

const FilterDropdown = ({ sortOption, roleFilter, statusFilter, setSortOption, setRoleFilter, setStatusFilter, onReset, onApply,
}) => (
    <div
        className="staff-filter-dropdown"
        onClick={(e) => e.stopPropagation()}
    >
        <div className="filter-section">
            <div className="filter-label"> Sort by </div>

            <div className="filter-option-row">
                {['Alphabetic', 'Newest', 'Oldest'].map(
                    (item) => (
                        <button
                            key={item}
                            type="button"
                            className={`filter-pill ${sortOption === item ? 'selected' : ''}`}
                            onClick={() => setSortOption(item)}
                        >
                            {item}
                        </button>
                    )
                )}
            </div>
        </div>

        <div className="filter-section">
            <div className="filter-label"> Role </div>

            <div className="filter-option-row">
                {['All', 'Teachers', 'Operations'].map(
                    (item) => (
                        <button
                            key={item}
                            type="button"
                            className={`filter-pill ${roleFilter === item ? 'selected' : ''}`}
                            onClick={() => setRoleFilter(item)}
                        >
                            {item}
                        </button>
                    )
                )}
            </div>
        </div>

        <div className="filter-section">
            <div className="filter-label"> Status </div>

            <div className="filter-option-row">
                {['Active', 'Suspended'].map(
                    (item) => (
                        <button
                            key={item}
                            type="button"
                            className={`filter-pill ${statusFilter === item ? 'selected' : ''}`}
                            onClick={() => setStatusFilter(item)}
                        >
                            {item}
                        </button>
                    )
                )}
            </div>
        </div>

        <div className="filter-footer">
            <button
                type="button"
                className="filter-reset-btn"
                onClick={onReset}
            >
                RESET
            </button>

            <button
                type="button"
                className="filter-apply-btn"
                onClick={onApply}
            >
                APPLY
            </button>
        </div>
    </div>
);

const mapStateToProps = (state) => {
    const { user } = state.session;
    const { usersList, userObj, standards, courses, selectedStandard, selectedCourse, storeWithoutData, userIds } = state.userManagementV2;
    const { staffList } = state.userManagementV3;
    const { resourceData } = state.feeManagement;
    return { usersList, userObj, standards, courses, user, selectedStandard, selectedCourse, resourceData, storeWithoutData, userIds, staffList };
};

const mapDispatchToProps = (dispatch) => ({
    getUsers: (params, callback) => dispatch(getUsers(params, callback)),
    getStaffListV3: (params, callback) => dispatch(getStaffListV3(params, callback)),
    searchStaffV3: (params, callback) => dispatch(searchStaffV3(params, callback)),
    updateStaffStatusV3: (userId, status, callback) => dispatch(updateStaffStatusV3(userId, status, callback)),
    setSpecificUserId: (id) => dispatch(setSpecificUserId(id)),
    updateUserToTranferData: (data) => dispatch(updateUserToTranferData(data)),
    setUserDetails: (res) => dispatch(setUserDetails(res)),
    setOthersSelectedTab: (tab) => dispatch(setOthersSelectedTab(tab))
});

export default connect(mapStateToProps, mapDispatchToProps)(UserTableV2);